function init () {
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (document.getElementsByClassName('banner').length > 0) {
      var banner = document.getElementsByClassName('banner')[0].offsetTop - 100;
      /* var in_con_1 = document.getElementsByClassName('in_con_1')[0].offsetTop - 100; */
      var in_con_2 = document.getElementsByClassName('in_con_2')[0].offsetTop - 100;
      var in_con_3 = document.getElementsByClassName('in_con_3')[0].offsetTop - 100;
      var in_con_4 = document.getElementsByClassName('in_con_4')[0].offsetTop - 100;
      var in_con_5 = document.getElementsByClassName('in_con_5')[0].offsetTop - 100;
      $(".in_yuandian a").removeClass("focus");
      if (scrollTop < in_con_2) {
        $(".in_yuandian a:eq(0)").addClass("focus");
      } else if (in_con_2 < scrollTop && scrollTop < in_con_3) {
        $(".in_yuandian a:eq(1)").addClass("focus");
      } else if (in_con_3 < scrollTop && scrollTop < in_con_4) {
        $(".in_yuandian a:eq(2)").addClass("focus");
      } else if (in_con_4 < scrollTop && scrollTop < in_con_5) {
        $(".in_yuandian a:eq(3)").addClass("focus");
      } else if (in_con_5 < scrollTop && scrollTop) {
        $(".in_yuandian a:eq(4)").addClass("focus");
      }
    }
  });
}

export {
  init
}



// WEBPACK FOOTER //
// ./src/assets/js/byl_index_scroll.js